import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const LevrageSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 20}
    height={props.height ? props.height : 20}
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="m9.504 1.075.45-.128-.257-.902-.45.129-8.75 2.5-.451.129.257.901.451-.129 8.75-2.5Zm-5.06 2.298L5 2.5l.556.873 3.223 5.064.596.938H.625l.597-.938 3.223-5.064Zm-2.11 5.064L5 4.246l2.668 4.191H2.333Z"
      clipRule="evenodd"
    />
  </svg>
)
export default LevrageSVG
